import {
  SearchSearchPatternRequest,
  DetailSearchPatternRequest,
  UpdateSearchPatternRequest,
  DeleteSearchPatternRequest,
  DetailSearchPatternResponse,
  SearchSearchPatternRecord,
  SearchSearchPatternResponse,
} from 'api-types/src/types/search-pattern';
import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18n/i18n';

type SearchPatternState = {
  loading: boolean;
  filterSearchTotal: number;
  filterInitialSearchData: SearchSearchPatternRecord[];
  filterSearchData: SearchSearchPatternRecord[];
  sortSelected: string;
  sortDirection: string;
  message: string;
  sqlDetail: DetailSearchPatternResponse | {};
  success: boolean;
};

const initialState: SearchPatternState = {
  loading: false,
  filterSearchTotal: 0,
  filterInitialSearchData: [],
  filterSearchData: [],
  sortSelected: '',
  sortDirection: '',
  message: '',
  sqlDetail: {},
  success: false,
};

export const searchPatternSlice = createSlice({
  name: 'searchPattern',
  initialState,
  reducers: {
    filterSql: (state, action: { payload: SearchSearchPatternRequest }) => {
      state.loading = true;
      state.message = '';
    },
    filterSqlSuccess: (state, action: { payload: SearchSearchPatternResponse }) => {
      state.loading = false;
      state.filterInitialSearchData = action.payload?.records;
      state.filterSearchData = action.payload?.records;
      if (!action.payload?.total) {
        state.message = i18n.t('message.common.0001');
      }
      state.filterSearchTotal = action.payload?.total;
      state.success = false;
    },
    filterSqlFailure: (state) => {
      state.loading = false;
    },
    getDetailSql: (state, action: { payload: DetailSearchPatternRequest }) => {
      state.loading = true;
    },
    getDetailSqlSuccess: (state, action: { payload: SearchSearchPatternResponse }) => {
      state.loading = false;
      state.sqlDetail = action.payload;
    },
    getDetailSqlFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    registerSql: (state, action: { payload: UpdateSearchPatternRequest }) => {
      state.loading = true;
      state.success = false;
    },
    registerSqlSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    registerSqlFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    updateSql: (state, action: { payload: UpdateSearchPatternRequest }) => {
      state.loading = true;
      state.success = false;
    },
    updateSqlSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    updateSqlFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    deleteSql: (state, action: { payload: DeleteSearchPatternRequest }) => {
      state.loading = true;
      state.success = false;
    },
    deleteSqlSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    deleteSqlFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload.message;
    },
    cleanDataSql: (state) => {
      state.sqlDetail = {};
    },
    cleanData: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const {
  filterSql,
  filterSqlSuccess,
  filterSqlFailure,
  getDetailSql,
  getDetailSqlSuccess,
  getDetailSqlFailure,
  registerSql,
  registerSqlSuccess,
  registerSqlFailure,
  updateSql,
  updateSqlSuccess,
  updateSqlFailure,
  deleteSql,
  deleteSqlSuccess,
  deleteSqlFailure,
  cleanDataSql,
  cleanData,
} = searchPatternSlice.actions;

export default searchPatternSlice.reducer;
